import script from "./Availability.vue?vue&type=script&setup=true&lang=js"
export * from "./Availability.vue?vue&type=script&setup=true&lang=js"

import "./Availability.vue?vue&type=style&index=0&id=31a2d900&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2827775840/src/entratafarmstownhomes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31a2d900"]])

export default __exports__